import React, { FC, ReactNode } from 'react';

import PropTypes from 'prop-types';

import { stylePropType, StylableComponent } from '@adsk/alloy-react-theme';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

type LabelProps = StylableComponent<HTMLSpanElement> & { children?: ReactNode };

const Label: FC<LabelProps> = ({ style, children, ...props }) => {
  return (
    <OverflowTooltip
      getTargetProps={() => ({
        style: {
          minWidth: 0,
          margin: `0 5px`,
          ...(style as object),
        },
      })}
      {...props}
    >
      {children}
    </OverflowTooltip>
  );
};

Label.displayName = 'Label';

Label.propTypes = {
  /* style object to add to the wrapper of the node */
  style: stylePropType,
  /* className to add to the wrapper of the node */
  className: PropTypes.string,
  /* child elements to render */
  children: PropTypes.any,
};

export default Label;
